<template>
  <page-view>
    <template slot="action">
      <a-space size="small">
        <a-button type="primary" @click="onSave" :loading="saveLoading">提交</a-button>
      </a-space>
    </template>
    <div id="Base-Props" style="position: absolute;top: 0"></div>
    <a-anchor class="t-anchor">
      <a-anchor-link href="#Base-Props" title="基础"/>
      <a-anchor-link href="#Table-Props" title="专家"/>
      <a-anchor-link href="#Link-Props" title="项目"/>
    </a-anchor>
    <a-card>
      <a-spin :spinning="spinLoading">
        <a-form-model :model="form" ref="form" :rules="rules" class="custom pick-100 form-input">
          <a-row v-if="!ifEdit">
            <process-selector @change="onChangeProcess"/>
          </a-row>
          <div class="hp-title">
            <div>&nbsp;</div>
            <span>基础信息</span>
          </div>
          <a-row>
            <a-col :span="7">
              <a-form-model-item label="申请处室" prop="applyDept">
                <dept-selector v-if="deptDisabled" :value="form.applyDept" @change="v => form.applyDept = v" style="width: 100%"/>
                <a-input v-else disabled v-model="deptName"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="申请人" prop="applyUser">
                <user-selector :value="form.applyUser" @change="v => form.applyUser = v" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="专家出行日期" prop="applyDate">
                <a-date-picker style="width: 100%" :format="'yyyy-MM-DD'" v-model="form.applyDate"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="7">
              <a-form-model-item label="计划使用天数" prop="planDays">
                <a-input-number @change="totalPrices" :min="0.5" :max="365"
                                :formatter="(value)=>{
                                              let reg = /^(-)*(\d+)\.(\d).*$/;
                                              return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg,'$1$2.$3');
                                            }"
                                :parser="(value)=>{
                                              let reg = /^(-)*(\d+)\.(\d).*$/;
                                              return value.replace(/\s?|(,*)/g, '').replace(reg,'$1$2.$3');
                                            }"
                                :step="0.5" v-model="form.planDays" style="width:100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="专业名称" prop="professionalName">
                <a-tree-select
                    show-search
                    style="width: 100%"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    allow-clear multiple
                    treeNodeFilterProp="title"
                    :tree-data="zyTreeData"
                    @change="values => form.professionalName = values.join(',')"
                    v-model="selZYData"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="专家人数" prop="expertNumber">
                <a-input-number :precision="0" @change="totalPrices" :min="1" :max="20" v-model="form.expertNumber" style="width:100%"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="7">
              <a-form-model-item label="计划专家费用" prop="planExpertFees">
                <dict-cascader @change="totalPrices" dictKey="expertExpenditure_reward" v-model="form.planExpertFees" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="总价" prop="planTotalPrices">
                <a-input readOnly disabled v-model="form.planTotalPrices"/>
              </a-form-model-item>
            </a-col>
          </a-row>

          <!--随机抽取专家-->
          <div id="Table-Props" style="position: absolute;top: 0"></div>
          <a-row>
            <a-col :span="23">
              <SelectExpert-table ref="SETable"
                                  :professionalName="form.professionalName"
                                  :expertNumber="form.expertNumber"
                                  :expertName="form.expertName"
                                  :cfmZJList="cfmZJList"
                                  :ifA="ifA"
                                  :is-random-show="false"
                                  @changeIfA="(ifa) => { ifA = ifa }"
                                  @change="(ids,names) => { form.selectExpert = ids; form.selectExpertName = names }"
                                  @changeReSelect="(reSelectList) => { form.reSelectList = reSelectList }"
              />
              <a-form-model-item label="" prop="selectExpert">
                <a-input style="display: none" v-model="form.selectExpertName"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <div class="hp-title">
            <div>&nbsp;</div>
            <span>项目信息</span>
          </div>
          <div id="Link-Props" style="position: absolute;bottom: 0"></div>
          <a-row>
            <a-col :span="23">
              <a-form-model-item label="项目名称" prop="projectName">
                <a-textarea v-model="form.projectName" rows="2"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="23">
              <a-form-model-item label="项目内容" prop="projectContent">
                <a-textarea v-model="form.projectContent" rows="4"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="23">
              <a-form-model-item label="补录或指定专家缘由" prop="recordReason">
                <a-textarea v-model="form.recordReason" rows="2"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import { verify } from '@epp/expertmain/common/js/verify'
import moment from 'moment'
import UserSelector from '@/components/selector/UserSelector'
import DeptSelector from '@/components/selector/DeptSelector'
import ProcessSelector from '@/components/workflow/ProcessSelector'
import DictCascader from '@/components/dict/DictCascader'
import SelectExpertTable from '@/epp/expertmain/selectexpertapply/common/SelectExpertTable'

const uuidv4 = require('uuid/v4')
const rules = {
  applyUser: [{ required: true, message: '申请人不能为空！', trigger: 'change' }],
  applyDept: [{ required: true, message: '申请处室不能为空！', trigger: 'change' }],
  applyDate: [{ required: true, message: '专家出行日期不能为空！', trigger: 'change' }],
  planDays: [{ required: true, message: '计划使用天数不能为空！', trigger: 'change' }],
  professionalName: [{ required: true, message: '专业名称不能为空！', trigger: 'change' }],
  planExpertFees: [{ required: true, message: '计划专家费用不能为空！', trigger: 'change' }],
  expertNumber: [{ required: true, message: '专家人数不能为空！', trigger: 'change' }],
  expertName: [{ min: 1, max: 10, pattern: verify.pattern_Chinese, message: '姓名有误！长度应在2~10个中文', trigger: 'blur' }],
  planTotalPrices: [{ required: true, message: '总价不能为空！', trigger: 'blur' }],
  selectExpert: [{ required: true, message: '请在填写完“专业名称”和“专家人数”之后点击“随机生成”抽取专家并点击“确定”选定专家！', trigger: 'change' }],
  projectName: [{ min: 1, max: 150, required: true, whitespace: true, message: '项目名称不能为空！最多150个字符', trigger: 'blur' }],
  projectContent: [{
    min: 1,
    max: 300,
    required: true,
    whitespace: true,
    message: '项目内容不能为空！最多300个字符',
    trigger: 'blur'
  }],
  recordReason: [{
    min: 1,
    max: 300,
    required: true,
    whitespace: true,
    message: '补录或指定专家缘由不能为空！最多300个字符',
    trigger: 'blur'
  }]
}
export default {
  name: 'AppointExpertAdd',
  components: {
    PageView,
    UserSelector,
    DeptSelector,
    ProcessSelector,
    DictCascader,
    SelectExpertTable
  },
  data () {
    return {
      rules,
      applyState: '1',
      extractInterval: 0,
      user: this.$ls.get('user'),
      setRuleVisible: false,
      saveLoading: false,
      spinLoading: false,
      ifLotto: false,
      ifEdit: false,
      ifA: true,
      procId: '',
      expertName: '', // 指定专家名称
      zyTreeData: [],
      selZYData: null,
      cfmZJList: [],
      extractRules: { id: null, extractInterval: null },
      form: {
        id: uuidv4()
      },
      id: this.$route.query.id,
      deptDisabled: false,
      deptName: '',
      modalVisible: {
        pact: false
      },
      caseTypeId: this.$route.query.caseTypeId
    }
  },
  created () {
    this.deptName = this.user.dept.name
    this.deptDisabled = this.user.permissions['expert.use.admin']
    if (this.id) {
      this.loadData()
      this.ifEdit = true
    } else {
      this.form = { ...this.initForm() }
    }
    this.loadZYTreeData()
  },
  watch: {
    id (val) {
      if (val) {
        this.loadData()
        this.ifEdit = true
      } else {
        this.form = { ...this.initForm() }
      }
    },
    form (val) {
      this.$emit('change', val)
    }
  },
  computed: {

  },
  methods: {
    initForm () {
      return {
        id: uuidv4(),
        applyUser: this.user.id,
        applyDept: this.user.deptId,
        applyDate: moment(),
        professionalName: null
      }
    },
    totalPrices () {
      if (!this.form.planDays) {
        return
      }
      var s = this.form.planDays.toString()
      var arr = s.split('.')
      if (arr.length > 1) {
        var s1 = arr[1] + '0'
        var s2 = s1.substring(0, 1)
        if (s2 > 5) {
          this.form.planDays = Number(arr[0]) + 1
        } else if (s2 < 5) {
          this.form.planDays = Number(arr[0]) + 0.5
        }
      }
      var totalPrices = 0
      if (this.form.planDays && this.form.expertNumber && this.form.planExpertFees) {
        totalPrices = this.form.planDays * this.form.expertNumber * this.form.planExpertFees
      }
      this.form.planTotalPrices = totalPrices
    },
    onChangeProcess (id) {
      // 选择流程
      this.procId = id
    },
    async loadData () {
      this.spinLoading = true
      const res = await this.$http.get(`/api/1/expertmain/selectExpertApply/get_selectExpertApply.json?id=${this.id}`)
      this.spinLoading = false
      if (res.code !== 200) {
        return
      }
      this.form = res.result
      this.form.applyDate = moment(this.form.applyDate)
      this.selZYData = res.result.professionalName.split(',')
      this.cfmZJList = res.result.extras.expertList
    },
    // 获取专业类别
    loadZYTreeData () {
      const that = this
      this.$http.get(`/api/1/dict/cache/items.json?key=expert_profession`).then(res => {
        if (res.code !== 200) {
          return
        }
        that.zyTreeData = that.mapTreeData(res.result)
      })
    },
    mapTreeData (list, type) {
      const that = this
      if (!list) {
        return []
      }
      return list.map(item => {
        return {
          key: item.id,
          // value: item.id + '|' + item.name,
          value: item.value,
          title: item.name,
          children: that.mapTreeData(item.children, type)
        }
      })
    },
    onSave () {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        if (this.procId.length === 0 && !this.ifEdit) {
          this.$message.error('未选择启动流程，请选择启动流程！')
          return
        }
        let selExpertNum = this.form.selectExpert.split(',')
        if (this.form.expertNumber < selExpertNum.length) {
          this.$message.error('选取专家的数量，大于所设置的专家数量！')
          return
        }
        const data = { ...this.form }
        data.procId = this.procId
        data.caseTypeId = this.$route.query.caseTypeId
        data.applyDate = data.applyDate.format('YYYY-MM-DD')
        data.applyState = this.applyState

        // console.log(data)
        // return

        delete data.extras
        const api = this.id ? '/api/1/expertmain/selectExpertApply/update_selectExpertApply.json' : '/api/1/expertmain/selectExpertApply/add_selectExpertApply.json'
        let msgType = this.id ? '编辑' : '添加'
        this.saveLoading = true
        const res = await this.$http.post(api, data)
        this.saveLoading = false
        if (res.code !== 200) {
          this.$message.error(`${msgType}失败`)
          return
        }
        this.$message.success(`${msgType}成功`)
        this.$router.push({
          path: '/selectExpertApply/view?id=' + data.id
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.hp-title {
  padding-top: 15px;
  padding-bottom: 15px;
}

.hp-title div {
  height: 18px;
  border-left: 5px solid dodgerblue;
  width: 15px;
  display: inline-block;
}

.hp-title span {
  font-size: 16px;
  font-weight: bold
}
</style>
